import { useSetAtom } from 'jotai';
import { useCallback, useRef } from 'react';
import { uiTourRefsAtom } from 'packages/omnitag/state';

export function useTourRef<T extends HTMLElement>(id: string) {
  const setRefs = useSetAtom(uiTourRefsAtom);
  const elementRef = useRef<T | null>(null); // Explicitly type useRef as T | null

  const callbackRef = useCallback(
    (node: T | null) => {
      // Update the internal ref
      elementRef.current = node;

      // Update the Jotai atom immediately when the node changes
      setRefs((prev) => {
        if (node) {
          // If node is present, add/update it in the refs
          return { ...prev, [id]: node };
        }
        // If node is null, it means the element is unmounting, so remove it from the refs
        const next = { ...prev };
        delete next[id];
        return next;
      });
    },
    [id, setRefs]
  );

  return callbackRef;
}
